import { isAdmin, isMember } from '@/policies/index';
var member = {
    index: function (company) {
        return isAdmin(company.user_type) || isMember(company.user_type);
    },
    create: function (company) {
        return isAdmin(company.user_type);
    },
    update: function (company) {
        return isAdmin(company.user_type);
    },
    delete: function (company) {
        return isAdmin(company.user_type);
    },
    deleteInvitationLink: function (company) {
        return isAdmin(company.user_type);
    }
};
export default member;
